<div *ngIf="cart$ | async as cart"
     class="mb-submit-order-wrapper"
     data-cy="mb-submit-order-wrapper">

  <mb-submit-order-term-condition
    [isTypeACheckout]="cart?.checkoutStatus?.checkoutType === mbCheckoutType.CHECKOUT_TYPE_A">
  </mb-submit-order-term-condition>

  <mb-submit-order-request *ngIf="!isPurchaseCheckout"
                           [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, cart)"
                           [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_MIX, cart)"
                           [totalPrice]="cart.totalPrice">
  </mb-submit-order-request>

  <ng-container *ngIf="isPurchaseCheckout">
    <mb-submit-order-price [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, cart)"
                           [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_AVAILABLE, cart)"
                           [totalPrice]="cart.totalPrice"
                           [showShippingTaxes]="true"
                           [prices]="cart"
                           [shouldDisplayErpPrices]="true">
    </mb-submit-order-price>
  </ng-container>

  <div class="row no-gutters mt-2 mb-submit-order-totals"
       data-cy="mb-submit-order-totals">

    <ng-container *ngIf="isPurchaseCheckout">
      <div class="col-4 mt-3"
           data-cy="mb-submit-order-title">
        {{'submitBox.orderTotal' | cxTranslate}}
      </div>

      <div class="col-8 mt-3 text-right"
           data-cy="mb-submit-order-price">
        <span>
          <span *ngIf="cart?.erpPricingError || (!cart.erpTotalPrice?.formattedValue && !cart.erpTotalListPrice?.formattedValue)">{{'submitBox.orderConfirmation' | cxTranslate}}</span>
          <strong *ngIf="!cart?.erpPricingError && cart.erpTotalPrice?.formattedValue" [innerHTML]="cart?.erpTotalPrice?.formattedValue | safeHtml"></strong>
          <strong *ngIf="!cart?.erpPricingError && !cart.erpTotalPrice?.formattedValue && cart.erpTotalListPrice?.formattedValue" [innerHTML]="cart?.erpTotalListPrice?.formattedValue | safeHtml"></strong>
        </span>
      </div>
    </ng-container>

    <div class="col-12 my-3 mb-request-info"
         data-cy="mb-submit-order-step-info">
      <span *ngIf="isPurchaseCheckout && cart?.erpPricingError" 
            [ngClass]="{ 'mb-span-space': shouldDisplayPaymentProvider }">{{'submitBox.orderConfirmationEmail' | cxTranslate}}</span>
      <span *ngIf="isPurchaseCheckout && !cart?.erpPricingError"
            [ngClass]="{ 'mb-span-space': shouldDisplayPaymentProvider }">{{'submitBox.pricesMessage' | cxTranslate}}</span>
      <span *ngIf="isPurchaseCheckout && shouldDisplayPaymentProvider">{{'submitBox.paymentInfo' | cxTranslate}}</span>
      <span *ngIf="!isPurchaseCheckout">{{'submitBox.requestInfo' | cxTranslate}}</span>
    </div>

    <div class="col-12 text-center"
         data-cy="mb-submit-order-checkout-btn">

      <button type="button"
              class="btn btn-lg btn-primary w-100 text-initial mb-buttons"
              mbOneClickAllowed
              (click)="onPlaceOrderClick()">
        <strong *ngIf="!isPurchaseCheckout">{{'submitBox.sendPriceRequest' | cxTranslate}}</strong>
        <strong *ngIf="isPurchaseCheckout">{{'submitBox.submitOrder' | cxTranslate}}</strong>
      </button>
    </div>
  </div>
</div>
